// src/hooks/useYoutube.js
import {useQuery} from "react-query";
import {fetchYoutubeList} from "../api/youtubeApi";

export const useYoutubeList = (pageNumber, pageSize) => {
    return useQuery(['youtubeList', pageNumber, pageSize], () => fetchYoutubeList(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
}
